// src/components/AboutSection.tsx
import { motion } from 'framer-motion';

interface MetricCardProps {
  value: string;
  label: string;
  index: number;
}

const MetricCard = ({ value, label, index }: MetricCardProps) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.3, delay: index * 0.1 }}
    className="p-6 bg-white border border-stone-200 rounded-lg shadow-md transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-secondary transform-none"
  >
    <div className="flex flex-col items-center">
      <div className="text-secondary font-bold text-3xl mb-1">{value}</div>
      <p className="text-stone-800 text-sm text-center">{label}</p>
    </div>
  </motion.div>
);

interface AboutSectionProps {
  metricsCards: {
    value: string;
    label: string;
  }[];
}

const AboutSection = ({ metricsCards }: AboutSectionProps) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-8">
      {/* About Us Text */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.5 }}
        className="text-lg text-stone-600"
      >
        <p className="mb-4">
          V Kamen d.o.o. smo že več kot 30 let predani zagotavljanju najkakovostnejših materialov in storitev za vaš dom. 
          Z bogatimi izkušnjami in strokovno ekipo vam zagotavljamo vrhunsko svetovanje in izvedbo.
        </p>
        <p className="mb-4">
          Naša široka ponudba keramike, naravnega kamna in pultov za kuhinjo in kopalnico vam omogoča, 
          da najdete popolne materiale za vaš novi dom ali renovacijo.
        </p>
        <p>
          S strokovnim pristopom in posložljunostjo vam pomagamo ustvariti prostor, ki bo odražal vaš stil in 
          izpolnjeval vaše potrebe. Obiščite našo trgovino ali nas kontaktirajte za brezplačno svetovanje.
        </p>
      </motion.div>
      
      {/* Metrics Cards Grid */}
      <div className="grid grid-cols-2 gap-4">
        {metricsCards.map((metric, index) => (
          <MetricCard 
            key={index}
            value={metric.value} 
            label={metric.label} 
            index={index} 
          />
        ))}
      </div>
    </div>
  );
};

export default AboutSection;